var render = function render(_c,_vm){return _c('svg',{class:_vm.props.plain ? null : 'flex-grow-0 flex-shrink-0 fill-current',attrs:{"width":_vm.props.large ? 24 : 16,"height":_vm.props.large ? 24 : 16}},[_c('use',_vm._b({},'use',{
      'xlink:href': `${require('~/assets/svg/glyphs.svg')}#${_vm.props.id}`,
    },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }